module.exports = __webpack_public_path__ + "static/img/4.04c5c7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/4.jpg
// module id = 1GKK
// module chunks = 0